<div class="grid config-grid">
  <!-- Campos por item -->
  <div class="col-12" [hidden]="aba !== 'campos'">
    <h4 class="mt-0 mb-1">Campos de cada item da listagem</h4>
    <small class="dica">Para cada item devolvido pela listagem acima, o valor do campo vira uma variável. Use <code>{{ exemploVariavel }}</code> no path do endpoint do recurso executado por item.</small>
    <div class="linha" *ngFor="let c of model.campos; let i = index">
      <input pInputText [attr.id]="'iterCampo' + i" [(ngModel)]="c.campo" placeholder="Campo da listagem (ex.: picId)" style="min-width: 14rem" />
      <i class="pi pi-arrow-right text-500"></i>
      <input pInputText [attr.id]="'iterVariavel' + i" [(ngModel)]="c.variavel" placeholder="Variável (ex.: IdPic)" style="min-width: 14rem" />
      <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-text p-button-danger" (onClick)="removerCampo(i)" pTooltip="Remover"></p-button>
    </div>
    <p-button label="Adicionar campo" icon="pi pi-plus" styleClass="p-button-sm p-button-text" (onClick)="adicionarCampo()"></p-button>
    <div class="preview mt-2" id="iterPreview" *ngIf="preview.length > 0">
      <div *ngFor="let p of preview">{{ p }}</div>
    </div>
  </div>

  <!-- Recurso executado por item -->
  <div class="col-12" [hidden]="aba !== 'filho'">
    <h4 class="mb-1">Recurso executado por item</h4>
    <small class="dica">Importação repetida uma vez para cada item da listagem. Só roda dentro da iteração, não aparece no fluxo principal.</small>
    <div class="grid">
      <div class="field col-12 md:col-6">
        <label for="iterRecursoNome" class="font-bold">Nome do recurso</label>
        <input pInputText id="iterRecursoNome" [(ngModel)]="model.filho.nome" class="w-full" />
      </div>
      <div class="field col-12 md:col-6">
        <label for="iterRecursoDescricao" class="font-bold">Descrição</label>
        <input pInputText id="iterRecursoDescricao" [(ngModel)]="model.filho.descricao" class="w-full" />
      </div>
    </div>
    <app-comando-api-form [model]="model.comandoFilho" [conexoes]="conexoes" [endpointsGlobais]="endpointsGlobais"
      prefixo="iterFilho" [mostrarCamposChave]="true" [variaveisEsperadas]="variaveis"></app-comando-api-form>
  </div>
</div>
